import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from '../Component/Sidebar';
import { UserContex } from '../context API/UserContext';
import edit from "./../images/pencil.png";
import delet from "./../images/delete.png";
const ManageContact = ({logout}) => {
  const [contactInfo,setContactInfo]=useState([])
   const [userData, setUserData] = useContext(UserContex);
   const navigate = useNavigate();
  console.log(contactInfo)
  useEffect(()=>{
    axios.get("https://back.waratechnology.com/api/contact/getcontact")
    .then((res)=>{
setContactInfo(res.data.data)
    })
    .catch((err)=>{
console.log(err)
    })
  },
  [])
  const handledelete = (id) => {
    axios
      .delete("https://back.waratechnology.com/api/contact/delcontact/" + id)
      .then((res) => console.log(res.data))
      .catch((err) => console.log(err));
    window.location.reload();
  };
  useEffect(() => {
    if (!userData.user) {
      navigate("/login");
    }
  });
  return (
    <div className="flex ">
      <Sidebar logout={logout} />
      <div className="container mx-auto p-4 ml-80">
        <h1 className="text-3xl font-bold mb-4">Contact</h1>
        <Link
          to="/addcontact"
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full"
        >
          Create New Contact
        </Link>
        <div className="mt-4 overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-200">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Address
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Email
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Phone
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Telegram
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider border border-slate-700"
                >
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {contactInfo.map((data, index) => (
                <tr>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900 tracking-wider border border-slate-700">
                    {data.address}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900 tracking-wider border border-slate-700">
                    {data.email}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900 tracking-wider border border-slate-700">
                    {data.phone}
                  </td>
                  <td className="px-6 py-3 text-left text-xs font-medium text-gray-900 tracking-wider border border-slate-700">
                    {data.telegram_contact}
                  </td>
                  <td className="flex justify-between items-center gap-1 px-3 py-8 text-center text-xs font-medium text-gray-900 uppercase tracking-wider border border-l-0 border-t-0 border-slate-700 ">
                    <Link
                      to={`/updatecontact/${data.id}`}
                      className="py-2 text-white  border-none "
                    >
                      <img className="w-7" src={edit} alt="" />
                    </Link>
                    <img className="w-7 cursor-pointer" src={delet} alt="" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default ManageContact
